export * from './account.service';
import { AccountService } from './account.service';
export * from './account.serviceInterface';
export * from './assegnazione-articolo-cedola-controller.service';
import { AssegnazioneArticoloCedolaControllerService } from './assegnazione-articolo-cedola-controller.service';
export * from './assegnazione-articolo-cedola-controller.serviceInterface';
export * from './audit-chiamate.service';
import { AuditChiamateService } from './audit-chiamate.service';
export * from './audit-chiamate.serviceInterface';
export * from './autenticazione.service';
import { AutenticazioneService } from './autenticazione.service';
export * from './autenticazione.serviceInterface';
export * from './cassieri.service';
import { CassieriService } from './cassieri.service';
export * from './cassieri.serviceInterface';
export * from './cittadini.service';
import { CittadiniService } from './cittadini.service';
export * from './cittadini.serviceInterface';
export * from './cittadino-account.service';
import { CittadinoAccountService } from './cittadino-account.service';
export * from './cittadino-account.serviceInterface';
export * from './cittadino-allegati-pratica.service';
import { CittadinoAllegatiPraticaService } from './cittadino-allegati-pratica.service';
export * from './cittadino-allegati-pratica.serviceInterface';
export * from './cittadino-assistenza.service';
import { CittadinoAssistenzaService } from './cittadino-assistenza.service';
export * from './cittadino-assistenza.serviceInterface';
export * from './cittadino-catalogo-bandi.service';
import { CittadinoCatalogoBandiService } from './cittadino-catalogo-bandi.service';
export * from './cittadino-catalogo-bandi.serviceInterface';
export * from './cittadino-catalogo-comuni.service';
import { CittadinoCatalogoComuniService } from './cittadino-catalogo-comuni.service';
export * from './cittadino-catalogo-comuni.serviceInterface';
export * from './cittadino-configurazione-form-bando.service';
import { CittadinoConfigurazioneFormBandoService } from './cittadino-configurazione-form-bando.service';
export * from './cittadino-configurazione-form-bando.serviceInterface';
export * from './cittadino-consensi.service';
import { CittadinoConsensiService } from './cittadino-consensi.service';
export * from './cittadino-consensi.serviceInterface';
export * from './cittadino-documenti-del-comune.service';
import { CittadinoDocumentiDelComuneService } from './cittadino-documenti-del-comune.service';
export * from './cittadino-documenti-del-comune.serviceInterface';
export * from './cittadino-pratiche.service';
import { CittadinoPraticheService } from './cittadino-pratiche.service';
export * from './cittadino-pratiche.serviceInterface';
export * from './cittadino-push-token.service';
import { CittadinoPushTokenService } from './cittadino-push-token.service';
export * from './cittadino-push-token.serviceInterface';
export * from './cittadino-registrazione.service';
import { CittadinoRegistrazioneService } from './cittadino-registrazione.service';
export * from './cittadino-registrazione.serviceInterface';
export * from './cittadino-servizi.service';
import { CittadinoServiziService } from './cittadino-servizi.service';
export * from './cittadino-servizi.serviceInterface';
export * from './cittadino-studenti-mensa.service';
import { CittadinoStudentiMensaService } from './cittadino-studenti-mensa.service';
export * from './cittadino-studenti-mensa.serviceInterface';
export * from './cittadino-voucher-controller.service';
import { CittadinoVoucherControllerService } from './cittadino-voucher-controller.service';
export * from './cittadino-voucher-controller.serviceInterface';
export * from './coda-comunicazioni.service';
import { CodaComunicazioniService } from './coda-comunicazioni.service';
export * from './coda-comunicazioni.serviceInterface';
export * from './collegamento-account.service';
import { CollegamentoAccountService } from './collegamento-account.service';
export * from './collegamento-account.serviceInterface';
export * from './comuni-superadmin.service';
import { ComuniSUPERADMINService } from './comuni-superadmin.service';
export * from './comuni-superadmin.serviceInterface';
export * from './comuni-vista-operativa-caller-scoped.service';
import { ComuniVistaOperativaCallerScopedService } from './comuni-vista-operativa-caller-scoped.service';
export * from './comuni-vista-operativa-caller-scoped.serviceInterface';
export * from './comunicazioni-manuali-destinatari.service';
import { ComunicazioniManualiDestinatariService } from './comunicazioni-manuali-destinatari.service';
export * from './comunicazioni-manuali-destinatari.serviceInterface';
export * from './comunicazioni-manuali-email.service';
import { ComunicazioniManualiEmailService } from './comunicazioni-manuali-email.service';
export * from './comunicazioni-manuali-email.serviceInterface';
export * from './configurazione-mensa-cittadino.service';
import { ConfigurazioneMensaCittadinoService } from './configurazione-mensa-cittadino.service';
export * from './configurazione-mensa-cittadino.serviceInterface';
export * from './cruscotto-direzionale.service';
import { CruscottoDirezionaleService } from './cruscotto-direzionale.service';
export * from './cruscotto-direzionale.serviceInterface';
export * from './data-e-ora.service';
import { DataEOraService } from './data-e-ora.service';
export * from './data-e-ora.serviceInterface';
export * from './documenti-del-comune-gestione.service';
import { DocumentiDelComuneGestioneService } from './documenti-del-comune-gestione.service';
export * from './documenti-del-comune-gestione.serviceInterface';
export * from './errori-client.service';
import { ErroriClientService } from './errori-client.service';
export * from './errori-client.serviceInterface';
export * from './errori-client-gestione.service';
import { ErroriClientGestioneService } from './errori-client-gestione.service';
export * from './errori-client-gestione.serviceInterface';
export * from './esercente-account.service';
import { EsercenteAccountService } from './esercente-account.service';
export * from './esercente-account.serviceInterface';
export * from './esercente-cassieri.service';
import { EsercenteCassieriService } from './esercente-cassieri.service';
export * from './esercente-cassieri.serviceInterface';
export * from './esercente-catalogo-bandi.service';
import { EsercenteCatalogoBandiService } from './esercente-catalogo-bandi.service';
export * from './esercente-catalogo-bandi.serviceInterface';
export * from './esercente-comuni.service';
import { EsercenteComuniService } from './esercente-comuni.service';
export * from './esercente-comuni.serviceInterface';
export * from './esercente-configurazione-form-bando.service';
import { EsercenteConfigurazioneFormBandoService } from './esercente-configurazione-form-bando.service';
export * from './esercente-configurazione-form-bando.serviceInterface';
export * from './esercente-consensi.service';
import { EsercenteConsensiService } from './esercente-consensi.service';
export * from './esercente-consensi.serviceInterface';
export * from './esercente-domande.service';
import { EsercenteDomandeService } from './esercente-domande.service';
export * from './esercente-domande.serviceInterface';
export * from './esercente-negozi.service';
import { EsercenteNegoziService } from './esercente-negozi.service';
export * from './esercente-negozi.serviceInterface';
export * from './esercente-profilo.service';
import { EsercenteProfiloService } from './esercente-profilo.service';
export * from './esercente-profilo.serviceInterface';
export * from './esercente-registrazione.service';
import { EsercenteRegistrazioneService } from './esercente-registrazione.service';
export * from './esercente-registrazione.serviceInterface';
export * from './esercente-rendicontazione.service';
import { EsercenteRendicontazioneService } from './esercente-rendicontazione.service';
export * from './esercente-rendicontazione.serviceInterface';
export * from './esercente-transazioni-voucher-pos.service';
import { EsercenteTransazioniVoucherPOSService } from './esercente-transazioni-voucher-pos.service';
export * from './esercente-transazioni-voucher-pos.serviceInterface';
export * from './esercenti.service';
import { EsercentiService } from './esercenti.service';
export * from './esercenti.serviceInterface';
export * from './esercenti-negozi-e-cassieri-backoffice.service';
import { EsercentiNegoziECassieriBackofficeService } from './esercenti-negozi-e-cassieri-backoffice.service';
export * from './esercenti-negozi-e-cassieri-backoffice.serviceInterface';
export * from './esercenti-scheda.service';
import { EsercentiSchedaService } from './esercenti-scheda.service';
export * from './esercenti-scheda.serviceInterface';
export * from './gestione-allegati-pratica.service';
import { GestioneAllegatiPraticaService } from './gestione-allegati-pratica.service';
export * from './gestione-allegati-pratica.serviceInterface';
export * from './gestione-comunicazioni-pratica.service';
import { GestioneComunicazioniPraticaService } from './gestione-comunicazioni-pratica.service';
export * from './gestione-comunicazioni-pratica.serviceInterface';
export * from './gestione-domande-esercente.service';
import { GestioneDomandeEsercenteService } from './gestione-domande-esercente.service';
export * from './gestione-domande-esercente.serviceInterface';
export * from './gestione-domande-esercente-per-conto-dellesercente.service';
import { GestioneDomandeEsercentePerContoDellesercenteService } from './gestione-domande-esercente-per-conto-dellesercente.service';
export * from './gestione-domande-esercente-per-conto-dellesercente.serviceInterface';
export * from './gestione-errata-corrige-transazioni-voucher.service';
import { GestioneErrataCorrigeTransazioniVoucherService } from './gestione-errata-corrige-transazioni-voucher.service';
export * from './gestione-errata-corrige-transazioni-voucher.serviceInterface';
export * from './gestione-eventi-pratica.service';
import { GestioneEventiPraticaService } from './gestione-eventi-pratica.service';
export * from './gestione-eventi-pratica.serviceInterface';
export * from './gestione-importazione-domande-esercente-da-altro-bando.service';
import { GestioneImportazioneDomandeEsercenteDaAltroBandoService } from './gestione-importazione-domande-esercente-da-altro-bando.service';
export * from './gestione-importazione-domande-esercente-da-altro-bando.serviceInterface';
export * from './gestione-note-pratica.service';
import { GestioneNotePraticaService } from './gestione-note-pratica.service';
export * from './gestione-note-pratica.serviceInterface';
export * from './gestione-pratiche.service';
import { GestionePraticheService } from './gestione-pratiche.service';
export * from './gestione-pratiche.serviceInterface';
export * from './gestione-pratiche-codice-anpre-conflitti.service';
import { GestionePraticheCodiceANPREConflittiService } from './gestione-pratiche-codice-anpre-conflitti.service';
export * from './gestione-pratiche-codice-anpre-conflitti.serviceInterface';
export * from './gestione-pratiche-edit-dati.service';
import { GestionePraticheEditDatiService } from './gestione-pratiche-edit-dati.service';
export * from './gestione-pratiche-edit-dati.serviceInterface';
export * from './gestione-pratiche-pdf-export.service';
import { GestionePratichePDFExportService } from './gestione-pratiche-pdf-export.service';
export * from './gestione-pratiche-pdf-export.serviceInterface';
export * from './gestione-pratiche-scoring.service';
import { GestionePraticheScoringService } from './gestione-pratiche-scoring.service';
export * from './gestione-pratiche-scoring.serviceInterface';
export * from './gestione-pratiche-submit-per-conto-del-cittadino.service';
import { GestionePraticheSubmitPerContoDelCittadinoService } from './gestione-pratiche-submit-per-conto-del-cittadino.service';
export * from './gestione-pratiche-submit-per-conto-del-cittadino.serviceInterface';
export * from './gestione-rendicontazione-esercenti.service';
import { GestioneRendicontazioneEsercentiService } from './gestione-rendicontazione-esercenti.service';
export * from './gestione-rendicontazione-esercenti.serviceInterface';
export * from './gestione-storico-pratica.service';
import { GestioneStoricoPraticaService } from './gestione-storico-pratica.service';
export * from './gestione-storico-pratica.serviceInterface';
export * from './graduatoria-controller.service';
import { GraduatoriaControllerService } from './graduatoria-controller.service';
export * from './graduatoria-controller.serviceInterface';
export * from './isee-cittadino.service';
import { ISEECittadinoService } from './isee-cittadino.service';
export * from './isee-cittadino.serviceInterface';
export * from './menu-cittadino.service';
import { MenuCittadinoService } from './menu-cittadino.service';
export * from './menu-cittadino.serviceInterface';
export * from './notifiche-push-invio-superadmin.service';
import { NotifichePushInvioSUPERADMINService } from './notifiche-push-invio-superadmin.service';
export * from './notifiche-push-invio-superadmin.serviceInterface';
export * from './operatori-comune.service';
import { OperatoriComuneService } from './operatori-comune.service';
export * from './operatori-comune.serviceInterface';
export * from './operatori-pratica.service';
import { OperatoriPraticaService } from './operatori-pratica.service';
export * from './operatori-pratica.serviceInterface';
export * from './operatori-servizio-mensa.service';
import { OperatoriServizioMensaService } from './operatori-servizio-mensa.service';
export * from './operatori-servizio-mensa.serviceInterface';
export * from './pago-pa-webhook.service';
import { PagoPAWebhookService } from './pago-pa-webhook.service';
export * from './pago-pa-webhook.serviceInterface';
export * from './passkey-web-authn.service';
import { PasskeyWebAuthnService } from './passkey-web-authn.service';
export * from './passkey-web-authn.serviceInterface';
export * from './permessi.service';
import { PermessiService } from './permessi.service';
export * from './permessi.serviceInterface';
export * from './pratiche-vista-operatore.service';
import { PraticheVistaOperatoreService } from './pratiche-vista-operatore.service';
export * from './pratiche-vista-operatore.serviceInterface';
export * from './profilo-cittadino.service';
import { ProfiloCittadinoService } from './profilo-cittadino.service';
export * from './profilo-cittadino.serviceInterface';
export * from './profilo-operatore-backoffice.service';
import { ProfiloOperatoreBackofficeService } from './profilo-operatore-backoffice.service';
export * from './profilo-operatore-backoffice.serviceInterface';
export * from './profilo-operatore-servizio.service';
import { ProfiloOperatoreServizioService } from './profilo-operatore-servizio.service';
export * from './profilo-operatore-servizio.serviceInterface';
export * from './segnalazioni-account-gestione.service';
import { SegnalazioniAccountGestioneService } from './segnalazioni-account-gestione.service';
export * from './segnalazioni-account-gestione.serviceInterface';
export * from './servizi.service';
import { ServiziService } from './servizi.service';
export * from './servizi.serviceInterface';
export * from './servizi-i-miei-servizi.service';
import { ServiziIMieiServiziService } from './servizi-i-miei-servizi.service';
export * from './servizi-i-miei-servizi.serviceInterface';
export * from './servizi-superadmin.service';
import { ServiziSUPERADMINService } from './servizi-superadmin.service';
export * from './servizi-superadmin.serviceInterface';
export * from './servizio-mensa-anagrafiche.service';
import { ServizioMensaAnagraficheService } from './servizio-mensa-anagrafiche.service';
export * from './servizio-mensa-anagrafiche.serviceInterface';
export * from './servizio-mensa-comunicazioni.service';
import { ServizioMensaComunicazioniService } from './servizio-mensa-comunicazioni.service';
export * from './servizio-mensa-comunicazioni.serviceInterface';
export * from './servizio-mensa-configurazione.service';
import { ServizioMensaConfigurazioneService } from './servizio-mensa-configurazione.service';
export * from './servizio-mensa-configurazione.serviceInterface';
export * from './servizio-mensa-menu.service';
import { ServizioMensaMenuService } from './servizio-mensa-menu.service';
export * from './servizio-mensa-menu.serviceInterface';
export * from './servizio-mensa-pagamenti.service';
import { ServizioMensaPagamentiService } from './servizio-mensa-pagamenti.service';
export * from './servizio-mensa-pagamenti.serviceInterface';
export * from './servizio-mensa-pasti-da-preparare.service';
import { ServizioMensaPastiDaPreparareService } from './servizio-mensa-pasti-da-preparare.service';
export * from './servizio-mensa-pasti-da-preparare.serviceInterface';
export * from './servizio-mensa-report.service';
import { ServizioMensaReportService } from './servizio-mensa-report.service';
export * from './servizio-mensa-report.serviceInterface';
export * from './servizio-mensa-reportistica-pagamenti.service';
import { ServizioMensaReportisticaPagamentiService } from './servizio-mensa-reportistica-pagamenti.service';
export * from './servizio-mensa-reportistica-pagamenti.serviceInterface';
export * from './servizio-mensa-scuole.service';
import { ServizioMensaScuoleService } from './servizio-mensa-scuole.service';
export * from './servizio-mensa-scuole.serviceInterface';
export * from './servizio-mensa-studenti.service';
import { ServizioMensaStudentiService } from './servizio-mensa-studenti.service';
export * from './servizio-mensa-studenti.serviceInterface';
export * from './servizio-operatori.service';
import { ServizioOperatoriService } from './servizio-operatori.service';
export * from './servizio-operatori.serviceInterface';
export * from './studente-cittadino-dettaglio.service';
import { StudenteCittadinoDettaglioService } from './studente-cittadino-dettaglio.service';
export * from './studente-cittadino-dettaglio.serviceInterface';
export * from './studenti-cittadino.service';
import { StudentiCittadinoService } from './studenti-cittadino.service';
export * from './studenti-cittadino.serviceInterface';
export * from './tariffa-mensa-cittadino.service';
import { TariffaMensaCittadinoService } from './tariffa-mensa-cittadino.service';
export * from './tariffa-mensa-cittadino.serviceInterface';
export * from './termini-e-privacy-gestione.service';
import { TerminiEPrivacyGestioneService } from './termini-e-privacy-gestione.service';
export * from './termini-e-privacy-gestione.serviceInterface';
export * from './tipo-pratica-attributo-controller.service';
import { TipoPraticaAttributoControllerService } from './tipo-pratica-attributo-controller.service';
export * from './tipo-pratica-attributo-controller.serviceInterface';
export * from './tipo-pratica-attributo-esercente-controller.service';
import { TipoPraticaAttributoEsercenteControllerService } from './tipo-pratica-attributo-esercente-controller.service';
export * from './tipo-pratica-attributo-esercente-controller.serviceInterface';
export * from './tipo-pratica-attributo-esercente-valori-controller.service';
import { TipoPraticaAttributoEsercenteValoriControllerService } from './tipo-pratica-attributo-esercente-valori-controller.service';
export * from './tipo-pratica-attributo-esercente-valori-controller.serviceInterface';
export * from './tipo-pratica-attributo-valori-controller.service';
import { TipoPraticaAttributoValoriControllerService } from './tipo-pratica-attributo-valori-controller.service';
export * from './tipo-pratica-attributo-valori-controller.serviceInterface';
export * from './tipo-pratica-canale-comunicazione-controller.service';
import { TipoPraticaCanaleComunicazioneControllerService } from './tipo-pratica-canale-comunicazione-controller.service';
export * from './tipo-pratica-canale-comunicazione-controller.serviceInterface';
export * from './tipo-pratica-clone.service';
import { TipoPraticaCloneService } from './tipo-pratica-clone.service';
export * from './tipo-pratica-clone.serviceInterface';
export * from './tipo-pratica-configurazione-form-cittadino.service';
import { TipoPraticaConfigurazioneFormCittadinoService } from './tipo-pratica-configurazione-form-cittadino.service';
export * from './tipo-pratica-configurazione-form-cittadino.serviceInterface';
export * from './tipo-pratica-configurazione-form-esercente.service';
import { TipoPraticaConfigurazioneFormEsercenteService } from './tipo-pratica-configurazione-form-esercente.service';
export * from './tipo-pratica-configurazione-form-esercente.serviceInterface';
export * from './tipo-pratica-configurazione-form-esercente-tradotto-operatore.service';
import { TipoPraticaConfigurazioneFormEsercenteTradottoOperatoreService } from './tipo-pratica-configurazione-form-esercente-tradotto-operatore.service';
export * from './tipo-pratica-configurazione-form-esercente-tradotto-operatore.serviceInterface';
export * from './tipo-pratica-configurazione-form-tradotto-operatore.service';
import { TipoPraticaConfigurazioneFormTradottoOperatoreService } from './tipo-pratica-configurazione-form-tradotto-operatore.service';
export * from './tipo-pratica-configurazione-form-tradotto-operatore.serviceInterface';
export * from './tipo-pratica-controller.service';
import { TipoPraticaControllerService } from './tipo-pratica-controller.service';
export * from './tipo-pratica-controller.serviceInterface';
export * from './tipo-pratica-convenzione-controller.service';
import { TipoPraticaConvenzioneControllerService } from './tipo-pratica-convenzione-controller.service';
export * from './tipo-pratica-convenzione-controller.serviceInterface';
export * from './tipo-pratica-da-template.service';
import { TipoPraticaDaTemplateService } from './tipo-pratica-da-template.service';
export * from './tipo-pratica-da-template.serviceInterface';
export * from './tipo-pratica-documento-controller.service';
import { TipoPraticaDocumentoControllerService } from './tipo-pratica-documento-controller.service';
export * from './tipo-pratica-documento-controller.serviceInterface';
export * from './tipo-pratica-evento-comunicazione-controller.service';
import { TipoPraticaEventoComunicazioneControllerService } from './tipo-pratica-evento-comunicazione-controller.service';
export * from './tipo-pratica-evento-comunicazione-controller.serviceInterface';
export * from './tipo-pratica-istituto-controller.service';
import { TipoPraticaIstitutoControllerService } from './tipo-pratica-istituto-controller.service';
export * from './tipo-pratica-istituto-controller.serviceInterface';
export * from './tipo-pratica-istituto-plesso-assegnazione-controller.service';
import { TipoPraticaIstitutoPlessoAssegnazioneControllerService } from './tipo-pratica-istituto-plesso-assegnazione-controller.service';
export * from './tipo-pratica-istituto-plesso-assegnazione-controller.serviceInterface';
export * from './tipo-pratica-istituto-plesso-controller.service';
import { TipoPraticaIstitutoPlessoControllerService } from './tipo-pratica-istituto-plesso-controller.service';
export * from './tipo-pratica-istituto-plesso-controller.serviceInterface';
export * from './tipo-pratica-operatori-controller.service';
import { TipoPraticaOperatoriControllerService } from './tipo-pratica-operatori-controller.service';
export * from './tipo-pratica-operatori-controller.serviceInterface';
export * from './tipo-pratica-regola-punteggio-categoria-controller.service';
import { TipoPraticaRegolaPunteggioCategoriaControllerService } from './tipo-pratica-regola-punteggio-categoria-controller.service';
export * from './tipo-pratica-regola-punteggio-categoria-controller.serviceInterface';
export * from './tipo-pratica-regola-punteggio-controller.service';
import { TipoPraticaRegolaPunteggioControllerService } from './tipo-pratica-regola-punteggio-controller.service';
export * from './tipo-pratica-regola-punteggio-controller.serviceInterface';
export * from './tipo-pratica-regola-punteggio-fascia-controller.service';
import { TipoPraticaRegolaPunteggioFasciaControllerService } from './tipo-pratica-regola-punteggio-fascia-controller.service';
export * from './tipo-pratica-regola-punteggio-fascia-controller.serviceInterface';
export * from './tipo-pratica-regola-punteggio-predicato-controller.service';
import { TipoPraticaRegolaPunteggioPredicatoControllerService } from './tipo-pratica-regola-punteggio-predicato-controller.service';
export * from './tipo-pratica-regola-punteggio-predicato-controller.serviceInterface';
export * from './tipo-pratica-stato-bando-operatore.service';
import { TipoPraticaStatoBandoOperatoreService } from './tipo-pratica-stato-bando-operatore.service';
export * from './tipo-pratica-stato-bando-operatore.serviceInterface';
export * from './voucher-controller.service';
import { VoucherControllerService } from './voucher-controller.service';
export * from './voucher-controller.serviceInterface';
export * from './whats-app-webhook.service';
import { WhatsAppWebhookService } from './whats-app-webhook.service';
export * from './whats-app-webhook.serviceInterface';
export const APIS = [AccountService, AssegnazioneArticoloCedolaControllerService, AuditChiamateService, AutenticazioneService, CassieriService, CittadiniService, CittadinoAccountService, CittadinoAllegatiPraticaService, CittadinoAssistenzaService, CittadinoCatalogoBandiService, CittadinoCatalogoComuniService, CittadinoConfigurazioneFormBandoService, CittadinoConsensiService, CittadinoDocumentiDelComuneService, CittadinoPraticheService, CittadinoPushTokenService, CittadinoRegistrazioneService, CittadinoServiziService, CittadinoStudentiMensaService, CittadinoVoucherControllerService, CodaComunicazioniService, CollegamentoAccountService, ComuniSUPERADMINService, ComuniVistaOperativaCallerScopedService, ComunicazioniManualiDestinatariService, ComunicazioniManualiEmailService, ConfigurazioneMensaCittadinoService, CruscottoDirezionaleService, DataEOraService, DocumentiDelComuneGestioneService, ErroriClientService, ErroriClientGestioneService, EsercenteAccountService, EsercenteCassieriService, EsercenteCatalogoBandiService, EsercenteComuniService, EsercenteConfigurazioneFormBandoService, EsercenteConsensiService, EsercenteDomandeService, EsercenteNegoziService, EsercenteProfiloService, EsercenteRegistrazioneService, EsercenteRendicontazioneService, EsercenteTransazioniVoucherPOSService, EsercentiService, EsercentiNegoziECassieriBackofficeService, EsercentiSchedaService, GestioneAllegatiPraticaService, GestioneComunicazioniPraticaService, GestioneDomandeEsercenteService, GestioneDomandeEsercentePerContoDellesercenteService, GestioneErrataCorrigeTransazioniVoucherService, GestioneEventiPraticaService, GestioneImportazioneDomandeEsercenteDaAltroBandoService, GestioneNotePraticaService, GestionePraticheService, GestionePraticheCodiceANPREConflittiService, GestionePraticheEditDatiService, GestionePratichePDFExportService, GestionePraticheScoringService, GestionePraticheSubmitPerContoDelCittadinoService, GestioneRendicontazioneEsercentiService, GestioneStoricoPraticaService, GraduatoriaControllerService, ISEECittadinoService, MenuCittadinoService, NotifichePushInvioSUPERADMINService, OperatoriComuneService, OperatoriPraticaService, OperatoriServizioMensaService, PagoPAWebhookService, PasskeyWebAuthnService, PermessiService, PraticheVistaOperatoreService, ProfiloCittadinoService, ProfiloOperatoreBackofficeService, ProfiloOperatoreServizioService, SegnalazioniAccountGestioneService, ServiziService, ServiziIMieiServiziService, ServiziSUPERADMINService, ServizioMensaAnagraficheService, ServizioMensaComunicazioniService, ServizioMensaConfigurazioneService, ServizioMensaMenuService, ServizioMensaPagamentiService, ServizioMensaPastiDaPreparareService, ServizioMensaReportService, ServizioMensaReportisticaPagamentiService, ServizioMensaScuoleService, ServizioMensaStudentiService, ServizioOperatoriService, StudenteCittadinoDettaglioService, StudentiCittadinoService, TariffaMensaCittadinoService, TerminiEPrivacyGestioneService, TipoPraticaAttributoControllerService, TipoPraticaAttributoEsercenteControllerService, TipoPraticaAttributoEsercenteValoriControllerService, TipoPraticaAttributoValoriControllerService, TipoPraticaCanaleComunicazioneControllerService, TipoPraticaCloneService, TipoPraticaConfigurazioneFormCittadinoService, TipoPraticaConfigurazioneFormEsercenteService, TipoPraticaConfigurazioneFormEsercenteTradottoOperatoreService, TipoPraticaConfigurazioneFormTradottoOperatoreService, TipoPraticaControllerService, TipoPraticaConvenzioneControllerService, TipoPraticaDaTemplateService, TipoPraticaDocumentoControllerService, TipoPraticaEventoComunicazioneControllerService, TipoPraticaIstitutoControllerService, TipoPraticaIstitutoPlessoAssegnazioneControllerService, TipoPraticaIstitutoPlessoControllerService, TipoPraticaOperatoriControllerService, TipoPraticaRegolaPunteggioCategoriaControllerService, TipoPraticaRegolaPunteggioControllerService, TipoPraticaRegolaPunteggioFasciaControllerService, TipoPraticaRegolaPunteggioPredicatoControllerService, TipoPraticaStatoBandoOperatoreService, VoucherControllerService, WhatsAppWebhookService];
